import React from 'react';
import './LiveDealsSkeleton.css';

export const LiveDealsSliderSkeleton = () => {
    // Simulating 4 cards for the desktop view of the slider
    const skeletons = Array(4).fill(0);

    const SkeletonCard = () => (
        <div className='lead-card skeleton-card'>
            <div className='row'>
                <div className='col-12 col-md-12 lead-image position-relative'>
                    <div className="skeleton-image skeleton-pulse" style={{ height: '100%', minHeight: '200px' }}></div>
                    <div className='skeleton-button skeleton-pulse position-absolute' style={{ right: '25px', bottom: '10px', width: '120px', height: '40px', border: '2px solid #fff' }}></div>
                </div>
                <div className='col-12 col-md-12'>
                    <div className='lead-info'>
                        <div className='row'>
                            <div className='col-12 col-md-12 mt-3'>
                                <div className='skeleton-title skeleton-pulse' style={{ height: '24px', width: '80%', marginBottom: '10px' }}></div>
                            </div>
                            <div className='col-12 col-md-12 mb-2 d-flex align-items-center justify-content-between'>
                                <div className='skeleton-pulse' style={{ width: '100px', height: '24px', borderRadius: '50px' }}></div>
                                <div className='skeleton-pulse' style={{ width: '80px', height: '28px', borderRadius: '4px' }}></div>
                            </div>
                            <div className='col-12 col-md-12 mb-0 d-flex justify-content-center'>
                                <div className='skeleton-text skeleton-pulse' style={{ width: '60%', height: '20px' }}></div>
                            </div>
                        </div>
                    </div>
                    <div className='lead-info-bottom'>
                        <div className='row'>
                            <div className='col-12 col-md-12 mb-1 d-flex position-relative align-items-center'>
                                <div className='skeleton-pulse rounded-circle me-2' style={{ width: '20px', height: '20px' }}></div>
                                <div className='skeleton-text skeleton-pulse mb-0' style={{ width: '50%' }}></div>
                            </div>
                            <div className='col-12 col-md-12 text-center mb-3 mt-2'>
                                <div className='row g-0 rounded-3 overflow-hidden features-box-2 border' style={{ height: '60px' }}>
                                    <div className='col-4 py-2 px-2 border-end d-flex flex-column align-items-center justify-content-center'>
                                        <div className='skeleton-pulse' style={{ width: '40px', height: '10px', marginBottom: '5px' }}></div>
                                        <div className='skeleton-pulse' style={{ width: '60px', height: '15px' }}></div>
                                    </div>
                                    <div className='col-4 py-2 px-2 border-end d-flex flex-column align-items-center justify-content-center'>
                                        <div className='skeleton-pulse' style={{ width: '40px', height: '10px', marginBottom: '5px' }}></div>
                                        <div className='skeleton-pulse' style={{ width: '60px', height: '15px' }}></div>
                                    </div>
                                    <div className='col-4 py-2 px-2 d-flex flex-column align-items-center justify-content-center'>
                                        <div className='skeleton-pulse' style={{ width: '40px', height: '10px', marginBottom: '5px' }}></div>
                                        <div className='skeleton-pulse' style={{ width: '60px', height: '15px' }}></div>
                                    </div>
                                </div>
                                <div className='skeleton-text skeleton-pulse mt-2 mx-auto' style={{ width: '90%', height: '12px' }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="container p-0">
            <div className="row">
                {skeletons.map((_, index) => (
                    <div key={index} className="col-12 col-md-6 col-lg-3 mb-4 d-none d-sm-block p-0">
                        <SkeletonCard />
                    </div>
                ))}
                {/* Mobile Single Card Skeleton */}
                <div className="col-12 d-block d-sm-none">
                    <SkeletonCard />
                </div>
            </div>
        </div>
    );
};

export const LiveDealsSearchSkeleton = () => {
    // Simulating 8 small cards for search results
    const skeletons = Array(8).fill(0);

    return (
        <div>
            <div className="row p-custom-grid">
                <div className="col-12 border-search-result pt-4 pb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3 m-1 search-result-header">
                        <div className="skeleton-title skeleton-pulse" style={{ width: '200px' }}></div>
                        <div className="skeleton-title skeleton-pulse" style={{ width: '150px' }}></div>
                    </div>
                    <div className="row">
                        {skeletons.map((_, index) => (
                            <div key={index} className="col-12 col-md-3 col-lg-3 p-1">
                                <div className='lead-card-2 skeleton-card'>
                                    <div className='row'>
                                        <div className='col-12 col-md-12 lead-2-image skeleton-wrapper'>
                                            <div className="skeleton-image skeleton-pulse"></div>
                                        </div>
                                        <div className='col-12 col-md-12 lead-info-2'>
                                            <div className='skeleton-title skeleton-pulse' style={{ width: '90%', marginTop: '10px' }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
